export default "__VITE_ASSET__DLKtVJl1__"